import { useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Check from '../../../components/Icons/Check'
import manageUsersMessages from '../../ManageUsers/messages'
import {
  CustomSelectWrapper,
  ItemIcon,
  SelectAnchor,
  SelectContentBlock,
  SelectDropdown,
  SelectHelpTitle,
  SelectInput,
  SelectText,
  SelectTitle,
  SelectWrapper,
  SubTitle
} from '../styledComponents'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'
import OutsideClickWrapper from '../../../utils/OutsideClickWrapper'

// TODO: Move to components

export const CustomSelect = ({
  value: currentValue,
  type: currentType,
  options,
  onChange,
  disabled,
  marginBottom,
  className,
  locale
}) => {
  const [open, setOpen] = useState(false)
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 })
  const wrapperRef = useRef()
  const dropdownRef = useRef()

  const toggle = () => {
    if (!open && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect()
      setDropdownPos({
        top: rect.bottom,
        left: rect.left,
        maxHeight: window.innerHeight - rect.bottom - 20
      })
    }
    setOpen(!open)
  }

  const handleClickOutside = () => {
    setOpen(false)
  }

  const helpLink =
    locale && locale === 'de'
      ? 'https://intercom-help.eu/docu-tools-helpcenter/de/articles/277779-projektmitglieder-und-rollen'
      : 'https://intercom-help.eu/docu-tools-helpcenter/en/articles/277779-project-members-and-roles'

  return (
    <OutsideClickWrapper
      onCloseIntent={handleClickOutside}
      active={open}
      ignoreRefs={[dropdownRef]}
    >
      <SelectWrapper className={className} ref={wrapperRef}>
        <SelectInput
          marginBottom={marginBottom}
          disabled={disabled}
          className="round-select"
          onClick={() => {
            if (!disabled) {
              toggle()
            }
          }}
        >
          <SelectText>
            {currentType &&
            currentType !== 'Custom' &&
            manageUsersMessages[`roleLabel${currentType}`] ? (
              <FormattedMessage
                {...manageUsersMessages[`roleLabel${currentType}`]}
              />
            ) : (
              <span>{currentValue}</span>
            )}
          </SelectText>
        </SelectInput>
        {open &&
          createPortal(
            <SelectDropdown
              ref={dropdownRef}
              style={{
                top: dropdownPos.top,
                left: dropdownPos.left,
                maxHeight: dropdownPos.maxHeight,
                overflowY: 'auto'
              }}
            >
              {options.map(({ label, value, type }, key) => (
                <CustomSelectWrapper
                  onClick={() => {
                    onChange({ label, value, type })
                    toggle()
                  }}
                  key={`select${key}`}
                  style={{ display: 'flex' }}
                >
                  <ItemIcon>
                    {currentValue === label && (
                      <Check
                        color={colorsOptions.secondaryColors.red.normal}
                        height={30}
                        width={30}
                      />
                    )}
                  </ItemIcon>
                  <SelectContentBlock>
                    <SelectTitle>
                      {type &&
                      type !== 'Custom' &&
                      manageUsersMessages[`roleLabel${type}`] ? (
                        <FormattedMessage
                          {...manageUsersMessages[`roleLabel${type}`]}
                        />
                      ) : (
                        <span>{label}</span>
                      )}
                    </SelectTitle>
                    {type !== 'Custom' &&
                      manageUsersMessages[`roleDescription${type}`] && (
                        <SubTitle to="#">
                          <FormattedMessage
                            {...manageUsersMessages[`roleDescription${type}`]}
                          />
                          {manageUsersMessages[`roleDescription${type}2`] && (
                            <span>
                              <br />
                              <FormattedMessage
                                {...manageUsersMessages[
                                  `roleDescription${type}2`
                                ]}
                              />
                            </span>
                          )}
                          {manageUsersMessages[`roleDescription${type}3`] && (
                            <span>
                              <br />
                              <FormattedMessage
                                {...manageUsersMessages[
                                  `roleDescription${type}3`
                                ]}
                              />
                            </span>
                          )}
                          {manageUsersMessages[`roleDescription${type}4`] && (
                            <span>
                              <br />
                              <FormattedMessage
                                {...manageUsersMessages[
                                  `roleDescription${type}4`
                                ]}
                              />
                            </span>
                          )}
                        </SubTitle>
                      )}
                  </SelectContentBlock>
                </CustomSelectWrapper>
              ))}
              <CustomSelectWrapper onClick={toggle} noHover>
                <SelectContentBlock>
                  <SelectHelpTitle>
                    <FormattedMessage
                      id="personas_needHelp"
                      values={{
                        helpLink: (
                          <SelectAnchor href={helpLink} target="_blank">
                            <FormattedMessage id="personas_ourSite" />{' '}
                          </SelectAnchor>
                        )
                      }}
                    />
                  </SelectHelpTitle>
                </SelectContentBlock>
              </CustomSelectWrapper>
            </SelectDropdown>,
            document.body
          )}
      </SelectWrapper>
    </OutsideClickWrapper>
  )
}

CustomSelect.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  marginBottom: PropTypes.number,
  disabled: PropTypes.bool,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  locale: PropTypes.string
}

export default CustomSelect
